import { deleteFile } from '../../../owners/form/utils/deleteFile';
import { createPictureCardDraggerProps } from '../../../../utils/filesManagement/createPictureCardDraggerProps';

/**
 * Generates drag-and-drop properties for an Ant Design Modal with picture-card list type.
 *
 * @param {function} t - Translation function for internationalization.
 * @param {function} dispatchAPI - API dispatch function.
 * @param {function} message - Function for displaying messages.
 * @param {Array} fileList - List of files.
 * @param {function} setFileList - Function to set the file list.
 * @returns {Object} - Drag-and-drop properties for Ant Design Modal.
 */
export const ownerDraggerProps = (
  t,
  dispatchAPI,
  message,
  fileList,
  setFileList
) =>
  createPictureCardDraggerProps(
    t,
    dispatchAPI,
    message,
    fileList,
    setFileList,
    deleteFile
  );
